import React from 'react'
import {

    FiX,

    } from "react-icons/fi";


const BottomSheet = ({ open, title, onClose, children }) => {
    return (
        <div
          className={`fixed inset-0 z-50 flex items-end justify-center transition-all ${
            open ? "visible" : "invisible"
          }`}
          aria-hidden={!open}
        >
          <div
            onClick={onClose}
            className={`absolute inset-0 bg-black/40 transition-opacity ${open ? "opacity-100" : "opacity-0"}`}
          />
    
          <div
            className={`relative w-full   min-h-max max-h-[85vh] bg-white rounded-t-3xl transform transition-transform ${
              open ? "translate-y-0" : "translate-y-full"
            }`}
          >
            <div className="flex items-center justify-between p-6 border-b border-gray-100">
              <h3 className="text-xl font-bold text-gray-900">{title}</h3>
              <button onClick={onClose} className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                <FiX size={18} />
              </button>
            </div>
    
            <div className="p-6 overflow-y-scroll max-h-[75vh]" >{children}</div>
          </div>
        </div>
      );
}

export default BottomSheet
